<template>
  <div class="mt-8 w-full h-full bg-white">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ProductsView',
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
};
</script>
